import { render, staticRenderFns } from "./TgHeaderBar.vue?vue&type=template&id=340b16a1&"
import script from "./TgHeaderBar.vue?vue&type=script&lang=js&"
export * from "./TgHeaderBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports